<div class="content">
  <div class="wz-head">
    <span class="wz-eyebrow">World Creation Wizard</span>
    <h2 class="wz-title">{{ mapName }} <span class="gold">identity</span></h2>
  </div>

  <p class="wz-lead">
    List your world's eras, newest first. Your map's history needs at least <strong>{{ requiredYears }} years</strong>.
  </p>

  <div class="era-table">
    <div class="era-head">
      <div class="col-type">Era</div>
      <div class="col-name">Name</div>
      <div class="col-years">Years</div>
      <div class="col-flavor">Flavour</div>
      <div class="col-actions"></div>
    </div>

    @for (era of eras; track era; let i = $index) {
      <div class="era-row">
        <div class="col-type">
          <span class="era-tag" [class.is-current]="era.type === 'Current'">{{ era.type }}</span>
        </div>

        <div class="col-name">
          <div class="era-field">
            <input type="text" class="wz-input" [(ngModel)]="era.name" [disabled]="era.lockedName"
              [placeholder]="era.lockedName ? 'Current era' : 'e.g. Age of Strife'"
              [class.is-invalid]="showErrorMsg && !era.lockedName && eraHasAnyInput(era) && !era.name"
              [attr.aria-label]="era.type + ' era name'" />
            @if (era.lockedName) {
              <svg class="era-lock" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-label="From your map file"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>
            }
          </div>
        </div>

        <div class="col-years">
          <div class="era-field">
            <input type="number" class="wz-input" [(ngModel)]="era.years" [disabled]="era.lockedYears"
              [placeholder]="era.lockedYears ? 'Years' : 'e.g. 500'"
              [class.is-invalid]="showErrorMsg && !era.lockedYears && eraHasAnyInput(era) && (era.years === null || era.years <= 0)"
              [attr.aria-label]="era.type + ' era length in years'" />
            @if (era.lockedYears) {
              <svg class="era-lock" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-label="From your map file"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>
            }
          </div>
        </div>

        <div class="col-flavor">
          <ng-select class="wt-select" [(ngModel)]="era.flavor" [items]="flavors" placeholder="Choose…"
            [class.is-invalid]="showErrorMsg && (era.type === 'Current' || eraHasAnyInput(era)) && !era.flavor"
            [clearable]="false" appendTo="body">
            <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
          </ng-select>
        </div>

        <div class="col-actions">
          @if (i >= 2) {
            <button type="button" class="era-remove" (click)="removeEra(i)" title="Remove era" aria-label="Remove era">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg>
            </button>
          }
        </div>
      </div>
    }

    <div class="era-foot">
      <button type="button" class="btn btn-dark btn-sm" (click)="addEra()">
        <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>
        Add era
      </button>
      <span class="era-total" [class.is-short]="isYearsDeficient">
        Total history <strong>{{ totalYears }} / {{ requiredYears }} years</strong>
      </span>
    </div>
  </div>

  <p class="wz-hint era-note">Fields with a lock come from your map file. Once you start a historical era, its name, years and flavour are all needed.</p>

  @if (showErrorMsg) {
    <div class="error-banner">
      <span class="error-text">{{ validationErrorText }}</span>
    </div>
  }

  <div class="wz-actions">
    <button type="button" class="btn btn-dark" (click)="onBack()">Back</button>
    <button type="button" class="btn btn-theme" (click)="onNext()">Next</button>
  </div>

  @if (showDeficiencyModal) {
    <div class="era-overlay" role="dialog" aria-modal="true" aria-labelledby="era-more-title">
      <div class="era-dialog">
        <h3 id="era-more-title">More history needed</h3>
        <p>A longer timeline is needed to create meaningful historical events. Add eras or more years to reach at least <strong>{{ requiredYears }} years</strong>.</p>
        <button type="button" class="btn btn-theme" (click)="showDeficiencyModal = false">OK</button>
      </div>
    </div>
  }
</div>
